// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TAi6fv{display:inline-block;position:relative;animation:JU44u6 1s linear infinite;overflow:hidden;transform-origin:100% 50%}.TAi6fv::before,.TAi6fv::after{position:absolute;top:0;right:-100%;bottom:0;left:0;border-radius:50%;transform:rotate(-45deg);animation:TUDZVn 0.5s linear infinite alternate;content:'';color:currentColor;border:2px solid currentColor;border-color:currentColor transparent transparent currentColor}.TAi6fv::after{opacity:0}@keyframes TUDZVn{0%{transform:rotate(-45deg)}100%{opacity:1;transform:rotate(115deg)}}@keyframes JU44u6{0%{transform:rotate(180deg)}45%{transform:rotate(198deg)}55%{transform:rotate(234deg)}100%{transform:rotate(540deg)}}.TAi6fv.POCthk{width:5px;height:10px}.TAi6fv.ber_CO{width:15px;height:30px}.TAi6fv.hUdbFJ{width:25px;height:50px}.TAi6fv.cootut{width:40px;height:80px}@media (min-width: 768px){.TAi6fv{width:25px;height:50px}}@media (max-width: 767px){.TAi6fv{width:15px;height:30px}}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `TAi6fv`,
	"wheel-rotate-semi": `JU44u6`,
	"wheelRotateSemi": `JU44u6`,
	"wheel-rotate-inner": `TUDZVn`,
	"wheelRotateInner": `TUDZVn`,
	"xsmall": `POCthk`,
	"small": `ber_CO`,
	"medium": `hUdbFJ`,
	"large": `cootut`
};
export default ___CSS_LOADER_EXPORT___;
